import { doctoresDestacados, doctoresInternacionales } from '../../../mocks/doctores';

export default function DoctoresDestacados() {
  const gemma = doctoresDestacados.find((d) => d.nombre.includes('Gemma'));
  const topDoctores = doctoresDestacados.filter((d) => !d.nombre.includes('Gemma')).slice(0, 4);

  return (
    <section id="doctores" className="py-24 bg-ice-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-petrol-700 mb-4">Top 5 Ortodoncistas</h2>
          <p className="text-xl text-petrol-500 max-w-3xl mx-auto">
            Los mejores profesionales reconocidos internacionalmente con amplia experiencia en ortodoncia avanzada.
          </p>
        </div>

        {gemma && (
          <div className="mb-12">
            <div className="bg-white rounded-3xl overflow-hidden shadow-xl border border-olive-500/30 hover:shadow-2xl transition-all duration-300">
              <div className="grid md:grid-cols-5">
                <div className="md:col-span-2 flex items-center justify-center p-10 bg-ice-100">
                  <div className="relative">
                    <span className="absolute -top-2 -right-2 bg-olive-500 text-white text-xs font-bold w-8 h-8 rounded-full flex items-center justify-center z-10">
                      #1
                    </span>
                    <div className="w-56 h-56 rounded-full overflow-hidden border-4 border-olive-500 flex items-center justify-center">
                      <img 
                        src={gemma.foto}
                        alt={gemma.nombre}
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  </div>
                </div>
                <div className="md:col-span-3 p-8 md:p-10 flex flex-col justify-center">
                  <div className="flex items-center gap-3 mb-2">
                    <span className="bg-olive-500 text-white text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">TOP 1</span>
                    <div className="flex items-center gap-2">
                      <img 
                        src={(gemma as any).logoClinica} 
                        alt={(gemma as any).clinica}
                        className="w-6 h-6 object-contain"
                      />
                      <span className="text-sm text-petrol-400">{(gemma as any).clinica} · Palma de Mallorca</span>
                    </div>
                  </div>
                  <h3 className="text-3xl font-bold text-petrol-700 mb-2">{gemma.nombre}</h3>
                  <p className="text-olive-500 font-semibold mb-4">{gemma.especializacion}</p>
                  <p className="text-petrol-500 mb-6 leading-relaxed text-sm">
                    Especialista en odontología estética y cosmética con certificación Invisalign. Con más de 15 años de experiencia, la Dra. Santamaría combina su práctica en E2 Dental Clinic en Palma de Mallorca con actividad internacional en clínicas de Abu Dhabi y Dubai, aportando una visión global a sus tratamientos.
                  </p>

                  <div className="grid grid-cols-3 gap-4 mb-6">
                    <div className="text-center bg-ice-100 rounded-xl py-3 px-2">
                      <div className="text-2xl font-bold text-petrol-700">{gemma.experiencia}</div>
                      <div className="text-xs text-petrol-400 mt-1">Años Exp.</div>
                    </div>
                    <div className="text-center bg-ice-100 rounded-xl py-3 px-2">
                      <div className="text-2xl font-bold text-petrol-700">{gemma.casosTratados}</div>
                      <div className="text-xs text-petrol-400 mt-1">Casos</div>
                    </div>
                    <div className="text-center bg-ice-100 rounded-xl py-3 px-2">
                      <div className="flex items-center justify-center gap-1">
                        {gemma.certificaciones.map((cert, i) => (
                          <i key={i} className={`${cert} text-olive-500`}></i>
                        ))}
                      </div>
                      <div className="text-xs text-petrol-400 mt-1">Certificaciones</div>
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-2 mb-6">
                    {gemma.especialidades.map((esp, i) => (
                      <span key={i} className="bg-sky-100 text-petrol-600 px-3 py-1 rounded-full text-sm whitespace-nowrap">
                        {esp}
                      </span>
                    ))}
                  </div>

                  <div className="flex flex-wrap items-center gap-4 text-sm text-petrol-500 mb-6">
                    <span className="flex items-center gap-2">
                      <i className="ri-phone-line text-olive-500"></i>
                      {(gemma as any).telefono}
                    </span>
                    <a href={(gemma as any).web} target="_blank" rel="noopener noreferrer nofollow" className="flex items-center gap-2 hover:text-olive-500 transition-colors cursor-pointer">
                      <i className="ri-global-line text-olive-500"></i>
                      e2.clinic
                    </a>
                  </div>

                  <div className="flex gap-3">
                    <a href="https://e2.clinic" target="_blank" rel="noopener noreferrer nofollow" className="bg-olive-500 text-white px-6 py-3 rounded-full font-semibold hover:bg-olive-600 transition-colors whitespace-nowrap cursor-pointer text-sm">
                      Solicitar Cita
                    </a>
                    <button className="border-2 border-olive-500 text-olive-500 px-6 py-3 rounded-full font-semibold hover:bg-olive-500 hover:text-white transition-colors whitespace-nowrap cursor-pointer text-sm">
                      Ver Perfil Completo
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {topDoctores.map((doctor, index) => (
            <div 
              key={index}
              className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="absolute relative">
                <span className="absolute -top-3 -left-3 bg-petrol-700 text-white text-xs font-bold w-8 h-8 rounded-full flex items-center justify-center z-10">
                  #{index + 2}
                </span>
              </div>
              <div className="flex justify-center mb-6">
                <div className="w-36 h-36 rounded-full overflow-hidden border-4 border-olive-500 flex items-center justify-center">
                  <img 
                    src={doctor.foto}
                    alt={doctor.nombre}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              <div className="text-center mb-4">
                <div className="flex items-center justify-center gap-2 mb-3">
                  <img 
                    src={(doctor as any).logoClinica} 
                    alt={(doctor as any).clinica}
                    className="w-8 h-8 object-contain"
                  />
                </div>
                <h3 className="text-xl font-bold text-petrol-700 mb-2">{doctor.nombre}</h3>
                <p className="text-olive-500 font-semibold text-sm mb-2">{doctor.especializacion}</p>
                <p className="text-xs text-petrol-400 mb-2">{(doctor as any).clinica}</p>
                <div className="flex items-center justify-center space-x-2 text-petrol-500 text-sm">
                  <span className="text-xl">{doctor.bandera}</span>
                  <span>{doctor.ciudad}</span>
                </div>
              </div>

              <div className="flex items-center justify-center space-x-3 mb-5">
                {doctor.certificaciones.map((cert, i) => (
                  <div key={i} className="w-8 h-8 bg-ice-100 rounded-full flex items-center justify-center">
                    <i className={`${cert} text-olive-500`}></i>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-2 gap-4 mb-5">
                <div className="text-center">
                  <div className="text-2xl font-bold text-petrol-700 mb-1">{doctor.experiencia}</div>
                  <div className="text-xs text-petrol-400">Años Exp.</div>
                </div>
                <div className="text-center">
                  <div className="text-2xl font-bold text-petrol-700 mb-1">{doctor.casosTratados}</div>
                  <div className="text-xs text-petrol-400">Casos</div>
                </div>
              </div>

              <div className="flex flex-wrap gap-2 mb-5 justify-center">
                {doctor.especialidades.map((esp, i) => (
                  <span key={i} className="bg-sky-100 text-petrol-600 px-3 py-1 rounded-full text-xs whitespace-nowrap">
                    {esp}
                  </span>
                ))}
              </div>

              <button className="w-full border-2 border-olive-500 text-olive-500 py-2.5 rounded-full font-semibold text-sm hover:bg-olive-500 hover:text-white transition-colors whitespace-nowrap cursor-pointer">
                Ver Perfil
              </button>
            </div>
          ))}
        </div>

        <div className="mt-16">
          <h3 className="text-3xl font-bold text-petrol-700 mb-8 text-center">Doctores Internacionales</h3>
          <div className="grid md:grid-cols-3 lg:grid-cols-6 gap-6">
            {doctoresInternacionales.map((doctor, index) => (
              <div 
                key={index}
                className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="flex justify-center mb-4">
                  <div className="w-24 h-24 rounded-full overflow-hidden border-2 border-olive-500 flex items-center justify-center">
                    <img 
                      src={doctor.foto}
                      alt={doctor.nombre}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
                <div className="flex justify-center mb-3">
                  <img 
                    src={(doctor as any).logoClinica} 
                    alt={(doctor as any).clinica}
                    className="w-10 h-10 object-contain"
                  />
                </div>
                <h4 className="text-center font-bold text-petrol-700 mb-2 text-sm">{doctor.nombre}</h4>
                <p className="text-center text-xs text-petrol-400 mb-2">{(doctor as any).clinica}</p>
                <div className="flex items-center justify-center space-x-1 text-petrol-500 mb-2">
                  <span className="text-lg">{doctor.bandera}</span>
                  <span className="text-xs">{doctor.pais}</span>
                </div>
                <p className="text-center text-xs text-olive-500 font-semibold mb-3">{doctor.especialidad}</p>
                <button className="w-full bg-olive-500 text-white py-2 rounded-full text-xs font-semibold hover:bg-olive-600 transition-colors whitespace-nowrap cursor-pointer">
                  Contactar
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
